// Local transaction log (per browser). On-chain history is fetched separately where available.
const KEY = "cw_txs";

export function loadTxs() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function addTx(tx) {
  const txs = loadTxs();
  txs.unshift({ ...tx, ts: Date.now() });
  localStorage.setItem(KEY, JSON.stringify(txs.slice(0, 100)));
}
